import axios from "axios";
import { DocumentsContactNote, DocumentsOrderContact, DocumentsOrderNote } from "../types";

const isResolvedAlertNoteText = (noteText?: string) => {
  const lowerNoteText = noteText?.toLowerCase() || "";
  return lowerNoteText.includes("blacklist resolved") || lowerNoteText.includes("has resolved this blacklist/patriot alert");
};

export const getAxiosErrorMessage = (error: unknown, fallbackMessage: string) => {
  if (!axios.isAxiosError(error)) {
    return fallbackMessage;
  }

  const responseData = error.response?.data as { message?: string; errorMessage?: string } | string | undefined;
  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }

  if (responseData && typeof responseData === "object") {
    return responseData.message || responseData.errorMessage || error.message || fallbackMessage;
  }

  return error.message || fallbackMessage;
};

export const getContactNoteAlertType = (contactNote?: DocumentsContactNote) => {
  const noteText = contactNote?.text || "";
  const lowerNoteText = noteText.toLowerCase();
  if (!noteText || isResolvedAlertNoteText(noteText) || contactNote?.isPopup === false) {
    return null;
  }
  if (lowerNoteText.includes("blacklist")) {
    return "blacklist";
  }
  if (lowerNoteText.includes("patriot")) {
    return "patriot";
  }
  return null;
};

export const isResolvableOrderAlertNote = (note?: DocumentsOrderNote) => {
  const noteText = note?.text?.toLowerCase() || "";
  return (noteText.includes("blacklist") || noteText.includes("patriot")) && !isResolvedAlertNoteText(noteText);
};

export const getDisplayContactNotes = (contact: DocumentsOrderContact) => {
  const structuredNotes = (contact.contactNotes || []).filter((note) => note.text);
  const notesToDisplay = structuredNotes.length
    ? structuredNotes
    : (contact.notes || "")
        .split(/\r?\n/)
        .map((text) => text.trim())
        .filter(Boolean)
        .map((text) => ({ text, isPopup: true }));

  return notesToDisplay.filter(
    (note, index, notes) => note.text && notes.findIndex((displayNote) => displayNote.text === note.text) === index
  );
};
